import OptionService from '../services/option.service';
const options = JSON.parse(localStorage.getItem('options'));
const initialState = options
    ? { status: { options: true }, options }
    : { status: { options: false }, option: null };
export const option = {
    namespaced: true,
    state: initialState,
    actions: {
        getPublic({ commit }) {
            return OptionService.getPublic().then(
                option => {
                    commit('optionSuccess', option);
                    return Promise.resolve(option);
                },
                error => {
                    commit('optionFailure');
                    return Promise.reject(error);
                }
            );
        },
        getPrivate({ commit }) {
            return OptionService.getPrivate().then(
                option => {
                    commit('optionSuccess', option);
                    return Promise.resolve(option);
                },
                error => {
                    commit('optionFailure');
                    return Promise.reject(error);
                }
            );
        }
    },
    mutations: {
        optionSuccess(state, option) {
            state.status.options = true;
            state.option = option;
        },
        optionFailure(state) {
            state.status.options = false;
            state.option = null;
        },
    }
};
